const Template = ()=> import('../views/td_test/template.vue');
export default[{
    path:'/template',
    name:'template',
    component:Template,
    meta: {
        title: "测试模板",
        keepAlive: false
    }
}]